import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';

// Components
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';

@NgModule({
  declarations: [
    // HeaderComponent is now standalone, so it's not declared here
    // FooterComponent is now standalone, so it's not declared here
  ],
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    TranslateModule,
    HeaderComponent, // Import the standalone component
    FooterComponent // Import the standalone component
  ],
  exports: [
    HeaderComponent,
    FooterComponent
  ]
})
export class CoreModule { } 